module.exports = __webpack_public_path__ + "media/images/logo-04d733eb.png";